import React from 'react';
import { defineBlock, smartProps, useInspectorControl, useSmartProp } from '@smartfire/gutenberg-react';

import style from './block.module.scss';
import { PanelBody, PanelRow, TextControl } from '@wordpress/components';

const Inspector = () => {
    const [idButton, setIdButton] = useSmartProp('idButton');

    return (
        <PanelBody title={'Id du bouton'}>
            <PanelRow>
                <TextControl value={idButton} onChange={setIdButton} />
            </PanelRow>
        </PanelBody>
    );
};

const Submit = ({ text, aspect, color, idButton }) => {
    useInspectorControl(Inspector);

    return (
        <div className={style.block}>
            <div className={style.requireMessage}>
                <span>* </span>
                champs obligatoires
            </div>
            <button type="submit" id={idButton || false}>
                Envoyer
            </button>
        </div>
    );
};

export default defineBlock({
    Block: Submit,
    smartProps: {
        text: smartProps.string.withDefault('envoyer'),
        idButton: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Submit',
        parent: ['smartfire/contact-column-form'],
    },
});
